import { render, staticRenderFns } from "./PerfilTrocarSenha.vue?vue&type=template&id=8476ee74"
import script from "./PerfilTrocarSenha.vue?vue&type=script&lang=js"
export * from "./PerfilTrocarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports